export default __webpack_public_path__ + "1b8984ee86fca96158fbc69ccd32af45.webp";